module.exports = {
  buildVersion: "0.1.40",
  buildDate: 1749297429755,
}